<template>
    <div v-if="isProfessional"><slot></slot></div>
</template>

<script lang="ts" setup>
    import { MeilisearchContactEmailBadgeAttributes } from '../partials/Form/EmailBadge.vue';
    import { ContactsIndexSchema } from '~/app/common/schemas/ContactsIndexSchema';
    const props = defineProps<{
        meilisearchContact: ContactsIndexSchema | MeilisearchContactEmailBadgeAttributes;
    }>();

    const isProfessional = computed(() => {
        const hasVatNumber = typeof props.meilisearchContact.vat_number === 'string' && props.meilisearchContact.vat_number.trim() !== '';
        const hasSiret = typeof props.meilisearchContact.siret === 'string' && props.meilisearchContact.siret.trim() !== '';

        return hasVatNumber || hasSiret;
    });
</script>
